export default __webpack_public_path__ + "static/media/default.93fa112aef13ebed5776e3905f33ed3b.svg";